// @ts-nocheck
const app = (s = {}) => s.app || {}

export const theme = (s = {}) => app(s).theme || {}

export const router = (s = {}) => app(s).router || {}

export const meta = (s = {}) => app(s).meta || {}

export const brand = (s = {}) => meta(s)?.brand || 'money'

export const location = (s = {}) => app(s).location || {}

export const query = (s = {}) => location(s).query || {}

export const pathname = (s = {}) => location(s).pathname || ''

export const consentUrl = (s = {}) => meta(s).consentUrl || ''

export const trustpilot = (s = {}, brandName) =>
  app(s)?.trustpilot?.find((tp) => tp?.brandName === brandName) || {}
